import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { cx } from 'class-variance-authority';
import Icon from './Icon';
type DropdownMenuItemProps = {
  iconBeforeName?: Icon.Name;
  iconBeforeClassName?: string;
  /** @default 'sm' */
  iconBeforeSize?: Icon.Size;
  iconAfterName?: Icon.Name;
  iconAfterClassName?: string;
  /** @default 'sm' */
  iconAfterSize?: Icon.Size;
  children?: ReactNode;
  className?: string;
  /** @default false */
  disabled?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
};
export default function DropdownMenuItem(t0) {
  const $ = _c(20);
  const {
    iconBeforeName,
    iconBeforeClassName,
    iconBeforeSize: t1,
    iconAfterName,
    iconAfterClassName,
    iconAfterSize: t2,
    children,
    className,
    disabled: t3,
    onClick
  } = t0;
  const iconBeforeSize = t1 === undefined ? "sm" : t1;
  const iconAfterSize = t2 === undefined ? "sm" : t2;
  const disabled = t3 === undefined ? false : t3;
  const t4 = !disabled && "text-gray-600 hover:bg-gray-100 hover:text-gray-800";
  const t5 = disabled && "cursor-not-allowed text-gray-400 hover:bg-transparent hover:text-gray-400";
  let t6;
  if ($[0] !== className || $[1] !== t4 || $[2] !== t5) {
    t6 = cx("group flex w-full items-center px-4 py-2 text-left text-sm font-medium leading-5", t4, t5, className);
    $[0] = className;
    $[1] = t4;
    $[2] = t5;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] !== disabled || $[5] !== iconBeforeClassName || $[6] !== iconBeforeName || $[7] !== iconBeforeSize) {
    t7 = iconBeforeName && <Icon name={iconBeforeName} size={iconBeforeSize} color="none" className={cx("mr-3", iconBeforeClassName, !disabled && "text-gray-400 group-hover:text-gray-500", disabled && "text-gray-300 group-hover:text-gray-300")} />;
    $[4] = disabled;
    $[5] = iconBeforeClassName;
    $[6] = iconBeforeName;
    $[7] = iconBeforeSize;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== disabled || $[10] !== iconAfterClassName || $[11] !== iconAfterName || $[12] !== iconAfterSize) {
    t8 = iconAfterName && <Icon name={iconAfterName} size={iconAfterSize} color="none" className={cx("ml-3", iconAfterClassName, !disabled && "text-gray-400 group-hover:text-gray-500", disabled && "text-gray-300 group-hover:text-gray-300")} />;
    $[9] = disabled;
    $[10] = iconAfterClassName;
    $[11] = iconAfterName;
    $[12] = iconAfterSize;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== children || $[15] !== onClick || $[16] !== t6 || $[17] !== t7 || $[18] !== t8) {
    t9 = <button onClick={onClick} type="button" role="menuitem" className={t6}>{t7}{children}{t8}</button>;
    $[14] = children;
    $[15] = onClick;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
}